<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th
              v-for="headerItem in headerItems"
              :key="headerItem"
            >
              {{ headerItem }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in formatedElevators"
            :key="item.id"
          >
            <td>
              <v-badge
                :content="item.isNew ? $t('display/offer:create.table.new') : false"
                :value="item.isNew"
                color="secondary"
              >
                {{item.title}}
              </v-badge>
            </td>
            <td>{{ item.keywords }}</td>
            <td>{{ item.value }}</td>
            <td>{{ item.playouts }}</td>
            <td><v-btn
              @click="hideElevator(item.id)"
              icon>
              <v-icon>visibility_off</v-icon>
            </v-btn></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "TableElevators",
  props: {
    elevators: Array
  },
  data() {
    return {
      formatedElevators: []
    }
  },
  computed: {
    headerItems() {
      return [
        this.$t('common:name'),
        this.$t('display/offer:create.table.keywords'),
        this.$t('display/offer:create.table.info'),
        this.$t('display/offer:create.table.monthly-playouts'),
        ''
      ];
    }
  },
  created() {
    this.formatElevator(this.elevators);
  },
  methods: {
    formatElevator(items) {
      let elevators = items;
      if (items === null) elevators = [];

      this.formatedElevators = [];
      elevators.forEach(
        (elevator) => {
          this.formatedElevators.push({
            title: elevator.name,
            isNew: elevator.isNew,
            keywords: this.getKeywords(elevator.tags),
            value: elevator.value,
            playouts: elevator.playouts === null ? this.$t('display/offer:create.table.not-enough-data') : elevator.playouts,
            id: elevator.elevatorId

          })
        }
      );
    },
    getKeywords(tags) {
      if (tags == null) return '';

      let keywords = '';
      tags.forEach(
        (tag) => {
          keywords += tag.name + ', ';
        }
      );

      return keywords.slice(0, -2);
    },
    hideElevator(elevatorId) {
      this.$emit('hideElevator', elevatorId);
    }
  }
}
</script>